<template>
  <!-- 此处为入口 公共部分可以放到这里 -->
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import error from '@/services/error'

  export default {
    name: 'app',
    components: {
    },
    mounted() {
      // 全局错误初始化
      error.init.call(this)
    }
}
</script>

<style>
#app {
  font-family: "Microsoft YaHei", 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 0;
  margin: 0;
}


</style>



// WEBPACK FOOTER //
// src/App.vue